import {
  NotificationDeliveryStatus
} from '@restore/clinicalTrialNotificationHistory/clinicalTrialNotificationHistory.types';
import { STATUS_PILL_CLASS, STATUS_LABEL } from '../constants';
import { twMerge } from '@utils/twMerge';

export const StatusPill = ({ status }: { status?: NotificationDeliveryStatus }) => {
  if (!status) {
    return <span className='font-medium text-1624 text-black'>-</span>;
  }
  return (
    <span
      className={twMerge(
        'inline-flex items-center rounded-[3.2rem] px-1.5 py-0.5 font-sans text-1216 font-medium',
        STATUS_PILL_CLASS[status]
      )}
    >
      {STATUS_LABEL[status]}
    </span>
  );
};
